import { Box, Stack } from "@mui/material";
import ComingSoonFeature from "../../components/ui/ComingSoonFeature";

const Reports = () => {
  return (
    <Box>
      <Stack spacing={4}>
        {/* Calendar Feature */}
        <Box>
          <ComingSoonFeature
            featureName="REPORTS"
            skeletonType="list"
            description="Advanced reports and analytics coming soon!"
            height={650}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default Reports;
